const initialState = () => ({
  loading: true,
  uaMembers: [],
  uaTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  uaTableSearch: '',
  uaSelectedCustomer: {},
  showActionModal: false,
  actionModalView: '',
  processing: false,
  selectedDate: {
    start: null,
    end: null,
  },
  selectedEventCode: '',
  typeOptions: [],
  selectedPartner: '',
  sortedCorporation: [],
});

export default initialState;
